import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-50" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = {
  role: "list",
  class: "grid grid-cols-1 gap-4 sm:gap-4 lg:grid-cols-3"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex-1 flex items-center justify-between bg-white rounded-2xl truncate" }
const _hoisted_6 = { class: "flex-1 px-8 py-2 text-lg truncate" }
const _hoisted_7 = { class: "text-xl transition duration-250 text-black font-extrabold" }
const _hoisted_8 = {
  key: 0,
  class: "text-sm transition duration-250 text-gray-900"
}
const _hoisted_9 = { class: "flex-shrink-0 pl-4 pr-4 flex items-center justify-center" }

import { injectStrict } from '../../plugins/vueServiceContainerPlugin';
import { UtilityServiceInterface } from '@/services/utilityServiceInterface';
import { CheckCircleIcon } from '@heroicons/vue/outline';


type ContractOption = {
  id: string,
  name: string,
  description: string,
  price: number,
  discountedPrice?: number,
  displayDiscount?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  props: {
    contractOptions: { type: Array, required: true },
    selected: { type: String, required: true }
  },
  emits: ["onContractSelected"],
  setup(__props: any, { emit }: { emit: ({(e: 'onContractSelected', id: string): void}), expose: any, slots: any, attrs: any }) {

const utilityService = injectStrict<UtilityServiceInterface>('UtilityServiceInterface');





const activationFee = (contractOption: ContractOption, discounted: boolean): string => {
  if (discounted) {
    if (contractOption.discountedPrice === 0) {
      return 'Free Activation';
    } else {
      return `$${contractOption.discountedPrice} Activation Fee`;
    }
  }
  return `$${contractOption.price} Activation Fee`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.contractOptions, (contractOption) => {
          return (_openBlock(), _createElementBlock("li", {
            onClick: ($event: any) => {emit('onContractSelected', contractOption.id);},
            key: contractOption.name,
            class: _normalizeClass(["transition duration-250 group col-span-1 flex shadow-sm rounded-2xl cursor-pointer border", [ __props.selected === contractOption.id ? 'border-black' : '' ]])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(utilityService).toTitleCase(contractOption.name)) + " Contract.", 1),
                _createElementVNode("p", {
                  class: _normalizeClass(['text-sm transition duration-250', contractOption.displayDiscount ? 'text-decoration-line: line-through text-gray-300' : 'text-gray-900'])
                }, _toDisplayString(activationFee(contractOption, false)), 3),
                (contractOption.displayDiscount)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(activationFee(contractOption, true)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["w-8 h-8 bg-white inline-flex items-center justify-center rounded-full bg-transparent", [ __props.selected === contractOption.id ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]])
                }, [
                  (__props.selected === contractOption.id)
                    ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                        key: 0,
                        class: "w-8 h-8",
                        "aria-hidden": "true"
                      }))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ])
          ], 10, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}
}

})